// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"kF2dy","search1":"_3IyWC","animateSvg":"_2pwFG","disabled":"_1NZap","button":"BZy1a","link":"_1xymv"};